const autocomplete = instantsearch.connectors.connectAutocomplete(
  ({ indices, refine, widgetParams }, isFirstRendering) => {
    const { container, onSelectChange } = widgetParams;

    if (isFirstRendering) {
      container.html(
        '<select id="ais-autocomplete" placeholder="Search using a keyword" ></select>'
      );

      container.find("select").selectize({
        options: [],
        valueField: "Question",
        labelField: "Question",
        highlight: true,
        onType: refine,
        onFocus(){
          $('#ais-autocomplete')[0].selectize.clear()
        },
        onBlur() {
          refine(this.getValue());
        },
        score() {
          return function () {
            return 1;
          };
        },
        onChange(value) {
          onSelectChange(value);
          refine(value);
        },
        render: {
          option(item) {
            //console.log("mylog",item)
            return `
              <div class="option" > 
				<div class="option-product">${item.Product == 'NEO Series' || item.Product == 'NEO Plus Series' ? item.Product : item.Subcategory}</div> 
				<div class='option-question'>${item.Question}</div>
              </div>
            `;
          },
        },
      });

      return;
    }

    const [select] = container.find("select");

    indices.forEach((index) => {
      select.selectize.clearOptions();
      index.results.hits.forEach((h) => select.selectize.addOption(h));
      select.selectize.refreshOptions(select.selectize.isOpen);
    });
  }
);

const search = instantsearch({
  indexName: "FAQ_QUESTIONS_LIVE",
  searchClient,
  routing: {
    router: instantsearch.routers.history(),
    stateMapping: instantsearch.stateMappings.simple(),
  },
});

const suggestions = instantsearch({
  indexName: "FAQ_QUESTIONS_LIVE",
  searchClient,
});

suggestions.addWidgets([
  instantsearch.widgets.configure({
    hitsPerPage: 5,
  }),
  autocomplete({
    container: $("#autocomplete"),
    onSelectChange(value) {
      index.search(value).then(({ hits }) => {
        if (!value) return;
        //ANCHOR click
        let hit = hits[0];
        //makes sure the correct question is linked
        for (const h of hits){
          if(h.Question == value){
            hit = h;
            break;
          }
        }
        let product = removeSpace(hit.Product);
        let category = removeSpace(hit.Category);
        let subcategory = removeSpace(hit.Subcategory);
        let question = "question" + removeSpace(hit.objectID);
        console.log(value);
        console.log(hits);
        document.location.href =
          "/pages/faqs#" +
          product +
          "-" +
          product+category +
          "-" +
          product+subcategory +
          "-" +
          question;
      });
    },
  }),
]);
suggestions.start();
search.start();

  
//up&down keys to scroll the dropdown
const handleArrow = (e) => {
  // console.log(e.key);
  if (e.key == "ArrowDown") {
    document.querySelector(".selectize-dropdown.single").scrollBy(0, 10);
  } else if (e.key == "ArrowUp") {
    document.querySelector(".selectize-dropdown.single").scrollBy(0, -10);
  }
};

//close box
const closeBox = document.createElement("div");
closeBox.setAttribute("id", "closeBox");
closeBox.setAttribute("style", "cursor:pointer");
closeBox.setAttribute("onclick", `$('#ais-autocomplete')[0].selectize.clear()`);
document.querySelector(".selectize-control.single").appendChild(closeBox);
